import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiEndpoints } from "@app/registered-user/core/constants";
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { ApiResponse, AppAuditLog, AuditHistory, AuditRecordHistory } from "@core/models";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class AuditHistoryService {
    httpOptions = {
        headers: new HttpHeaders({ 'spinner': 'no' })
    };

    constructor(private http: HttpClient) {}

    getAuditHistory(userId: string): Observable<AuditHistory[]> {
        return this.http.get(ApiEndpoints.getAuditHistory + userId)
            .pipe(
                map(d => this.mapAuditHistoryData(d)),
                catchError(this.handleError<AuditHistory[]>('getAuditHistory', []))
            );
    }

    private mapAuditHistoryData(data: any) {
        const datepipe: DatePipe = new DatePipe('en-US');
        let auditHistoryData: AuditHistory[] = [];
        data.forEach(historyItem => {
            historyItem.modifiedDate = datepipe.transform(historyItem.modifiedDate, 'dd-MM-yyyy hh:mm a');
            historyItem.recordHistory = <AuditRecordHistory[]>JSON.parse(historyItem.recordHistory);
            auditHistoryData.push(historyItem);
        });
        return auditHistoryData;
    }

    createApplicationAuditLog(appAuditData: AppAuditLog): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(ApiEndpoints.createApplicationAuditLog, appAuditData)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('createApplicationAuditLog', null))
      );
    }

    /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}